import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { Switch } from '@quick/components/Switch';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';
import { serviceTypeOffersRequirements } from './utils';

export function ContainerAndSealsRequirements() {
  const { t } = useAppTranslation(['demand']);
  const { serviceType } = useFormDataContext();
  const { watch, setValue } = useFormContext<IForm>();
  const requiresContainer = watch('requires_container');
  const requiresSeals = watch('requires_seals');

  const offersRequirements = serviceTypeOffersRequirements(serviceType);
  // Wait for the service type: it is undefined while the form data loads
  const mustClear = !!serviceType && !offersRequirements;
  const hasRequirements = !!requiresContainer || !!requiresSeals;

  useEffect(() => {
    if (!mustClear || !hasRequirements) return;
    setValue('requires_container', false);
    setValue('requires_seals', false);
  }, [mustClear, hasRequirements, setValue]);

  if (!offersRequirements) return null;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
        <Switch
          id="requires-container"
          checked={requiresContainer ?? false}
          handleChange={() =>
            setValue('requires_container', !requiresContainer)
          }
          text={t('demand:requirements.container')}
          className="items-center font-medium"
        />
        <Switch
          id="requires-seals"
          checked={requiresSeals ?? false}
          handleChange={() => setValue('requires_seals', !requiresSeals)}
          text={t('demand:requirements.seals')}
          className="items-center font-medium"
        />
      </div>
      {requiresSeals && (
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {t('demand:requirements.sealsHelp')}
        </p>
      )}
    </div>
  );
}
